import { Link } from 'react-router-dom';
import { AlertRuleList } from '@/components/alerts/AlertRuleList';

export function AlertsPage() {
  return (
    <div className="space-y-6">
      <div className="flex items-center justify-between">
        <div>
          <h1 className="text-2xl font-bold text-gray-900">Alerts</h1>
          <p className="text-sm text-gray-500 mt-1">
            Configure alert rules for your positions
          </p>
        </div>
        <Link
          to="/alerts/history"
          className="text-sm text-brand-600 hover:text-brand-700"
        >
          View History
        </Link>
      </div>

      <AlertRuleList />
    </div>
  );
}
